import {
	actionLabel,
	isCircleAction,
	reasonLabel,
	resultLabel,
	summarizeRow,
} from '../SupportCircles/circleLogLabels';

// GH-841: labels for the generic "לוג פעילות" list. Support-circle rows (actionCategory SUPPORT_CIRCLE) get Hebrew
// labels from the circles registry; every other row keeps showing its raw action exactly as before.

/** actionCategory filter (the UserActivityLog ActionCategory enum) */
export const CATEGORY_CHOICES = [
	{ id: 'SUPPORT_CIRCLE', name: 'מעגלי תמיכה' },
	{ id: 'AUTH', name: 'התחברות' },
	{ id: 'APPOINTMENT', name: 'פגישות' },
	{ id: 'MEETING', name: 'מפגשים' },
	{ id: 'VIDEO', name: 'וידאו' },
	{ id: 'LECTURE', name: 'הרצאות' },
	{ id: 'PROFILE', name: 'פרופיל' },
	{ id: 'MESSAGING', name: 'הודעות' },
	{ id: 'PROACTIVE', name: 'פניות יזומות' },
	{ id: 'REWARDS', name: 'פרסים' },
	{ id: 'DATING', name: 'דייטינג' },
	{ id: 'ONBOARDING', name: 'שאלון פתיחה' },
	{ id: 'SEARCH', name: 'חיפוש' },
	{ id: 'PASS_IT_ON', name: 'פרגון' },
	{ id: 'LEARNING', name: 'למידה' },
	{ id: 'ARTICLE', name: 'מאמרים' },
	{ id: 'REVIEW', name: 'ביקורות' },
	{ id: 'QUESTIONS', name: 'שאלות' },
	{ id: 'SAFE_SPACE', name: 'מרחב בטוח' },
	{ id: 'STEP_CHALLENGE', name: 'אתגר צעדים' },
	{ id: 'OTHER', name: 'אחר' },
];

/** the "פעולה" cell: "מעגלי תמיכה · בקשת טוקן כניסה · נכשל / סורב: מוקדם מדי" for circle rows, the raw action otherwise */
export const logActionText = (record: any): string => {
	const action = record?.action ? String(record.action) : '';
	if (!isCircleAction(action)) return action;
	const result = record?.result ? String(record.result) : '';
	const reason = record?.metadata?.reason;
	const failed = !!result && result !== 'SUCCESS';
	return [
		'מעגלי תמיכה',
		actionLabel(action),
		failed ? `${resultLabel(result)}${reason ? `: ${reasonLabel(reason)}` : ''}` : '',
	]
		.filter(Boolean)
		.join(' · ');
};

/** the "מטא-דאטה" cell for a circle row: the Hebrew one-liner (the JSON stays in the tooltip) */
export const circleLogSummary = (record: any): string => {
	const action = record?.action ? String(record.action) : '';
	if (!isCircleAction(action)) return '';
	const meta = record?.metadata && typeof record.metadata === 'object' ? record.metadata : {};
	return summarizeRow({ action, result: record?.result, reason: meta.reason, subReason: meta.sub_reason, event: meta.event, meta });
};

/** a platform cell: empty stays empty ('-'); it used to read "ios", which was wrong for server-written rows */
export const platformText = (platform?: string) => (platform && String(platform).trim() ? String(platform) : '-');
